import React, { useState } from "react";
import adminImage from "../../../assets/images/me.jpg";
import question from "../../../assets/images/question.png";
import BiLogo from "../../IconsPack/BiLogo";
import useUserProfile from "../../../customHooks/useUserProfile";
import CustomLoader from "../../../utils/custom-loader";

interface SupportProps {
  title: string;
  description: string;
  subtitle: string;
  userProfile: {
    name: string;
    imageUrl: string;
  };
  metrics: {
    adminImage?: string | undefined;
    label: string;
    name?: string;
    role?: string;
    goal?: string;
    total?: number;
    approved?: number;
    rejected?: number;
    currentStat?: string;
    jobOpportuinity?: string;
  }[];
  table: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: string | number;
    }[];
  };
}

const Support: React.FC<SupportProps> = ({ description }) => {
  const [selectedNavItem, setSelectedNavItem] = useState(6);
  const [userProfile, isLoading, error] = useUserProfile();
  if (isLoading) {
    return <CustomLoader isLoading={true} />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="flex h-screen">
      
      <div className="flex-1">
        {/* Page Content */}
        <div className="bg-[#F3F6FF] pl-[350px] pr-[60px] py-20 pt-[120px] items-center justify-center">
      
          <div className="bg-white shadow rounded-[8px] py-[20px] px-[60px] mb-[20px] flex items-center">
            <div className="flex-1">
              <h2 className="text-[24px] font-ubuntu font-[500]">
                {description}
              </h2>
              <div className="flex items-center gap-x-[6px] mt-[12px]">
                <div className="items-center bg-[#F9F9F9] rounded-[5px] md:h-[45px] h-[45px] md:w-[237px] w-[237px] flex justify-center">
                  <input
                    type="text"
                    placeholder="How can we help you?"
                    className="text-[15px] text-gray-500 ml-[15px] font-ubuntu font-[400] bg-transparent focus:outline-none md:w-full w-full placeholder:italic"
                  />
                </div>
                <button className="bg-[#F9F9F9] text-white font-ubuntu font-[500] rounded-[5px] md:h-[45px] h-[45px] md:w-[50px] w-[50px] flex items-center justify-center">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.0387 25.9875C25.6137 26.5625 26.5012 25.675 25.9262 25.1125L21.2387 20.4125C22.8834 18.5933 23.7923 16.2273 23.7887 13.775C23.7887 8.28745 19.3262 3.82495 13.8387 3.82495C8.35117 3.82495 3.88867 8.28745 3.88867 13.775C3.88867 19.2625 8.35117 23.725 13.8387 23.725C16.3137 23.725 18.6012 22.8125 20.3512 21.3L25.0387 25.9875ZM5.13742 13.775C5.13742 8.97495 9.04992 5.07495 13.8374 5.07495C18.6374 5.07495 22.5374 8.97495 22.5374 13.775C22.5374 18.575 18.6374 22.475 13.8374 22.475C9.04992 22.475 5.13742 18.575 5.13742 13.775Z"
                      fill="black"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="flex flex-col items-center ml-8 py-[15px]">
              <img
                src={question}
                alt="question illustration"
                className="w-[134px] md:w-[134px] md:h-[114px] h-[114px] object-cover"
              />
            </div>
          </div>

          <div className="bg-white shadow rounded-[8px] py-[40px] px-[60px] mt-[6px] mb-[20px] flex items-center">
            {" "}
            <div className="flex-1">
              {" "}
              <h2 className="text-[24px] text-center font-ubuntu font-[500]">
                Feel free to go through these.
              </h2>{" "}
              <p className="text-[14px] text-center font-ubuntu font-[300]">
                Our FAQs make it easier.
              </p>{" "}
              <div className="grid md:grid-cols-4 grid-cols-3 md:gap-12 gap-12 mt-[35px]">
                {" "}
                <div className="bg-white shadow-lg rounded-[8px] py-[40px] px-[5px] flex flex-col items-center gap-y-4 transition-all duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 60 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.2833 40.1933C21.7567 40.1933 22.1522 40.0333 22.47 39.7133C22.7878 39.3933 22.9478 38.9978 22.95 38.5267V21.4733C22.95 21.0022 22.79 20.6067 22.47 20.2867C22.15 19.9667 21.7533 19.8067 21.28 19.8067C20.8067 19.8067 20.4111 19.9667 20.0933 20.2867C19.7756 20.6067 19.6167 21.0022 19.6167 21.4733V38.5267C19.6167 38.9978 19.7767 39.3933 20.0967 39.7133C20.4167 40.0333 20.8122 40.1933 21.2833 40.1933ZM33.5333 38.1233L43.2 31.7C43.8067 31.2933 44.11 30.7289 44.11 30.0067C44.11 29.2844 43.8067 28.7156 43.2 28.3L33.5333 21.88C32.8711 21.4089 32.1811 21.3678 31.4633 21.7567C30.7456 22.1456 30.3867 22.7522 30.3867 23.5767V36.4233C30.3867 37.2456 30.7456 37.8522 31.4633 38.2433C32.1811 38.6322 32.87 38.5911 33.53 38.12M30.0133 60C25.8667 60 21.9667 59.2133 18.3133 57.64C14.6622 56.0644 11.4856 53.9267 8.78334 51.2267C6.08112 48.5267 3.94223 45.3533 2.36667 41.7067C0.791116 38.06 0.00222691 34.1611 4.68823e-06 30.01C-0.00221753 25.8589 0.785561 21.9589 2.36334 18.31C3.93667 14.6589 6.07112 11.4822 8.76667 8.78C11.4622 6.07778 14.6367 3.93889 18.29 2.36333C21.9433 0.787778 25.8433 0 29.99 0C34.1367 0 38.0367 0.787778 41.69 2.36333C45.3411 3.93667 48.5178 6.07222 51.22 8.77C53.9222 11.4678 56.0611 14.6422 57.6367 18.2933C59.2122 21.9444 60 25.8433 60 29.99C60 34.1367 59.2133 38.0367 57.64 41.69C56.0667 45.3433 53.9289 48.52 51.2267 51.22C48.5244 53.92 45.3511 56.0589 41.7067 57.6367C38.0622 59.2144 34.1667 60.0022 30.0133 60ZM30 56.6667C37.4444 56.6667 43.75 54.0833 48.9167 48.9167C54.0833 43.75 56.6667 37.4444 56.6667 30C56.6667 22.5556 54.0833 16.25 48.9167 11.0833C43.75 5.91667 37.4444 3.33333 30 3.33333C22.5556 3.33333 16.25 5.91667 11.0833 11.0833C5.91667 16.25 3.33334 22.5556 3.33334 30C3.33334 37.4444 5.91667 43.75 11.0833 48.9167C16.25 54.0833 22.5556 56.6667 30 56.6667Z"
                        fill="#4ECB71"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Getting Started
                  </h3>
                </div>{" "}
                <div className="bg-white shadow-lg rounded-[8px] py-[40px] px-[5px] flex flex-col items-center gap-y-4 transition-all duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="71"
                      height="61"
                      viewBox="0 0 71 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M27.3334 0.333252C23.7972 0.333252 20.4058 1.73801 17.9053 4.23849C15.4048 6.73898 14.0001 10.1304 14.0001 13.6666C14.0001 17.2028 15.4048 20.5942 17.9053 23.0947C20.4058 25.5952 23.7972 26.9999 27.3334 26.9999C30.8696 26.9999 34.261 25.5952 36.7615 23.0947C39.262 20.5942 40.6667 17.2028 40.6667 13.6666C40.6667 10.1304 39.262 6.73898 36.7615 4.23849C34.261 1.73801 30.8696 0.333252 27.3334 0.333252ZM27.3334 6.99992C29.1015 6.99992 30.7972 7.7023 32.0475 8.95254C33.2977 10.2028 34.0001 11.8985 34.0001 13.6666C34.0001 15.4347 33.2977 17.1304 32.0475 18.3806C30.7972 19.6309 29.1015 20.3333 27.3334 20.3333C25.5653 20.3333 23.8696 19.6309 22.6194 18.3806C21.3691 17.1304 20.6667 15.4347 20.6667 13.6666C20.6667 11.8985 21.3691 10.2028 22.6194 8.95254C23.8696 7.7023 25.5653 6.99992 27.3334 6.99992ZM50.6667 26.9999C50.1334 26.9999 49.8667 27.2666 49.8667 27.7999L49.0001 31.9999C48.2667 32.5999 47.2001 33.1333 46.4001 33.6666L42.1334 31.9999C41.8667 31.9999 41.3334 31.9999 41.0667 32.3333L37.8667 38.1999C37.6001 38.4666 37.6001 38.9999 38.1334 39.2666L41.6001 41.9999V45.3333L38.1334 48.0666C37.8667 48.3332 37.6001 48.8666 37.8667 49.1332L41.0667 54.9999C41.3334 55.3332 41.8667 55.3333 42.1334 55.3333L46.4001 53.6666C47.2001 54.1999 48.2667 54.7332 49.0001 55.3333L49.8667 59.5333C49.8667 60.0666 50.1334 60.3333 50.6667 60.3333H57.3334C57.6001 60.3333 58.1334 60.0666 58.1334 59.5333L58.6667 55.3333C59.7334 54.7332 60.8001 54.1999 61.6001 53.6666L65.6667 55.3333C66.1334 55.3333 66.6667 55.3332 66.6667 54.9999L70.1334 49.1332C70.4001 48.8666 70.1334 48.3332 69.8667 48.0666L66.4001 45.3333V41.9999L69.8667 39.2666C70.1334 38.9999 70.4001 38.4666 70.1334 38.1999L66.6667 32.3333C66.6667 31.9999 66.1334 31.9999 65.6667 31.9999L61.6001 33.6666C60.8001 33.1333 59.7334 32.5999 58.6667 31.9999L58.1334 27.7999C58.1334 27.2666 57.6001 26.9999 57.3334 26.9999H50.6667ZM27.3334 30.3333C18.4334 30.3333 0.666748 34.7666 0.666748 43.6666V53.6666H32.9001C31.9667 51.6999 31.3001 49.5666 30.9667 47.3333H7.00008V43.6666C7.00008 41.5333 17.4334 36.6666 27.3334 36.6666C28.7667 36.6666 30.2334 36.7999 31.6667 36.9999C32.3334 34.8666 33.2334 32.8666 34.4001 31.0333C31.8001 30.5999 29.3334 30.3333 27.3334 30.3333ZM54.1334 38.6666C56.8001 38.6666 59.0001 40.8666 59.0001 43.7999C59.0001 46.4666 56.8001 48.6666 54.1334 48.6666C51.2001 48.6666 49.0001 46.4666 49.0001 43.7999C49.0001 40.8666 51.2001 38.6666 54.1334 38.6666Z"
                        fill="#1C98F7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Account Settings
                  </h3>
                </div>{" "}
                <div className="bg-white shadow-lg rounded-[8px] py-[40px] px-[5px] flex flex-col items-center gap-y-4 transition-all duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.2222 44.2678C30.6906 44.2678 37.5556 37.3928 37.5556 28.9122C37.5556 20.4316 30.6906 13.5566 22.2222 13.5566C13.7539 13.5566 6.88892 20.4316 6.88892 28.9122C6.88892 37.3928 13.7539 44.2678 22.2222 44.2678Z"
                        fill="#FCEA2B"
                        stroke="#FCEA2B"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M20.4423 44.3444C16.9379 49.1644 12.2223 51.1111 5.55566 51.1111C8.749 48.9822 11.9423 44.8133 13.1823 41.5366L20.4423 44.3444Z"
                        fill="#FCEA2B"
                      />
                      <path
                        d="M57.7779 61.1999C66.2463 61.1999 73.1112 54.3349 73.1112 45.8665C73.1112 37.3982 66.2463 30.5332 57.7779 30.5332C49.3095 30.5332 42.4446 37.3982 42.4446 45.8665C42.4446 54.3349 49.3095 61.1999 57.7779 61.1999Z"
                        fill="#FCEA2B"
                        stroke="#FCEA2B"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M59.5579 61.3222C63.0623 66.1422 67.7779 68.0889 74.4445 68.0889C71.2512 65.96 68.0579 61.7911 66.8179 58.5144L59.5579 61.3222Z"
                        fill="#FCEA2B"
                      />
                      <path
                        d="M14.4444 31.1112C15.6717 31.1112 16.6666 30.1163 16.6666 28.889C16.6666 27.6617 15.6717 26.6667 14.4444 26.6667C13.2171 26.6667 12.2222 27.6617 12.2222 28.889C12.2222 30.1163 13.2171 31.1112 14.4444 31.1112Z"
                        fill="black"
                      />
                      <path
                        d="M22.2222 31.1112C23.4495 31.1112 24.4444 30.1163 24.4444 28.889C24.4444 27.6617 23.4495 26.6667 22.2222 26.6667C20.9949 26.6667 20 27.6617 20 28.889C20 30.1163 20.9949 31.1112 22.2222 31.1112Z"
                        fill="black"
                      />
                      <path
                        d="M30.0001 31.1112C31.2274 31.1112 32.2223 30.1163 32.2223 28.889C32.2223 27.6617 31.2274 26.6667 30.0001 26.6667C28.7728 26.6667 27.7778 27.6617 27.7778 28.889C27.7778 30.1163 28.7728 31.1112 30.0001 31.1112Z"
                        fill="black"
                      />
                      <path
                        d="M13.1823 41.5366C11.9423 44.8144 8.749 48.9822 5.55566 51.1111C12.2223 51.1111 16.9379 49.1644 20.4423 44.3444"
                        stroke="black"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M24.7501 44.2399C32.139 43.0333 37.7779 36.6188 37.7779 28.8888C37.7779 20.2977 30.8134 13.3333 22.2223 13.3333C13.6312 13.3333 6.66675 20.2977 6.66675 28.8888C6.66675 32.5933 7.96119 35.9944 10.1223 38.6666"
                        stroke="black"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                      />
                      <path
                        d="M65.5555 48.089C66.7828 48.089 67.7777 47.0941 67.7777 45.8668C67.7777 44.6395 66.7828 43.6445 65.5555 43.6445C64.3282 43.6445 63.3333 44.6395 63.3333 45.8668C63.3333 47.0941 64.3282 48.089 65.5555 48.089Z"
                        fill="black"
                      />
                      <path
                        d="M57.7779 48.089C59.0052 48.089 60.0001 47.0941 60.0001 45.8668C60.0001 44.6395 59.0052 43.6445 57.7779 43.6445C56.5506 43.6445 55.5557 44.6395 55.5557 45.8668C55.5557 47.0941 56.5506 48.089 57.7779 48.089Z"
                        fill="black"
                      />
                      <path
                        d="M50.0001 48.089C51.2274 48.089 52.2223 47.0941 52.2223 45.8668C52.2223 44.6395 51.2274 43.6445 50.0001 43.6445C48.7728 43.6445 47.7778 44.6395 47.7778 45.8668C47.7778 47.0941 48.7728 48.089 50.0001 48.089Z"
                        fill="black"
                      />
                      <path
                        d="M66.8179 58.5144C68.0579 61.7922 71.2512 65.96 74.4445 68.0888C67.7779 68.0888 63.0623 66.1422 59.5579 61.3222"
                        stroke="black"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M55.2499 61.2177C47.8611 60.011 42.2222 53.5966 42.2222 45.8666C42.2222 37.2755 49.1866 30.311 57.7777 30.311C66.3688 30.311 73.3333 37.2755 73.3333 45.8666C73.3333 49.571 72.0388 52.9721 69.8777 55.6444"
                        stroke="black"
                        strokeWidth="2.22222"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Interviews
                  </h3>
                </div>{" "}
                <div className="bg-white shadow-lg rounded-[8px] py-[40px] px-[5px] flex flex-col items-center gap-y-4 transition-all duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clipRule="evenodd"
                        d="M47.9534 41.1117C47.4939 39.8116 46.6425 38.686 45.5166 37.8899C44.3907 37.0938 43.0457 36.6664 41.6667 36.6667V35H38.3334V36.6667C36.5653 36.6667 34.8696 37.369 33.6194 38.6193C32.3691 39.8695 31.6667 41.5652 31.6667 43.3333C31.6667 45.1014 32.3691 46.7971 33.6194 48.0474C34.8696 49.2976 36.5653 50 38.3334 50V56.6667C36.8834 56.6667 35.6484 55.7417 35.1884 54.445C35.1202 54.2329 35.0101 54.0366 34.8646 53.8677C34.7192 53.6989 34.5414 53.5609 34.3417 53.462C34.142 53.363 33.9245 53.3052 33.702 53.2918C33.4796 53.2784 33.2567 53.3097 33.0466 53.384C32.8365 53.4582 32.6434 53.5738 32.4787 53.724C32.3141 53.8742 32.1812 54.0558 32.088 54.2582C31.9948 54.4606 31.9431 54.6797 31.936 54.9024C31.9289 55.1252 31.9666 55.3471 32.0467 55.555C32.5063 56.8551 33.3576 57.9807 34.4835 58.7768C35.6094 59.5729 36.9545 60.0002 38.3334 60V61.6667H41.6667V60C43.4349 60 45.1305 59.2976 46.3808 58.0474C47.631 56.7971 48.3334 55.1014 48.3334 53.3333C48.3334 51.5652 47.631 49.8695 46.3808 48.6193C45.1305 47.369 43.4349 46.6667 41.6667 46.6667V40C42.3561 39.9998 43.0286 40.2134 43.5915 40.6113C44.1544 41.0091 44.5802 41.5718 44.8101 42.2217C44.9573 42.6385 45.264 42.9798 45.6629 43.1704C45.8603 43.2649 46.0745 43.3194 46.2931 43.3311C46.5116 43.3427 46.7304 43.3112 46.9367 43.2383C47.1431 43.1655 47.3332 43.0526 47.496 42.9063C47.6587 42.76 47.7911 42.583 47.8855 42.3856C47.9799 42.1881 48.0345 41.9739 48.0462 41.7554C48.0578 41.5368 48.0263 41.3181 47.9534 41.1117ZM38.3334 40C37.4494 40 36.6015 40.3512 35.9764 40.9763C35.3513 41.6014 35.0001 42.4493 35.0001 43.3333C35.0001 44.2174 35.3513 45.0652 35.9764 45.6904C36.6015 46.3155 37.4494 46.6667 38.3334 46.6667V40ZM41.6667 56.6667C42.5508 56.6667 43.3986 56.3155 44.0238 55.6904C44.6489 55.0652 45.0001 54.2174 45.0001 53.3333C45.0001 52.4493 44.6489 51.6014 44.0238 50.9763C43.3986 50.3512 42.5508 50 41.6667 50V56.6667Z"
                        fill="#B28800"
                      />
                      <path
                        fill-rule="evenodd"
                        clipRule="evenodd"
                        d="M21.9217 14.3683C26.0117 12.3667 32.7217 10 40.065 10C47.255 10 53.7884 12.2683 57.8567 14.2433L58.0867 14.355C59.3134 14.9617 60.3034 15.535 61 16L54.8434 25C69.0367 39.51 80 69.995 40.065 69.995C0.130049 69.995 10.7984 40.0633 25.115 25L18.9984 16C19.47 15.6917 20.0684 15.3333 20.7817 14.9533C21.135 14.7633 21.515 14.5672 21.9217 14.3683ZM50.8867 24.8817L55.815 17.6767C51.2317 18.0067 45.7784 19.0833 40.5284 20.6033C36.7784 21.6867 32.6117 21.5217 28.7534 20.81C27.7811 20.63 26.8154 20.4154 25.8584 20.1667L29.0584 24.8783C35.9167 27.32 44.0267 27.32 50.8867 24.8817ZM27.1334 27.7167C35.1584 30.8167 44.8034 30.8167 52.8284 27.7133C56.1773 31.2452 58.9794 35.2579 61.1417 39.6183C63.3951 44.215 64.6217 48.81 64.4217 52.77C64.2284 56.5917 62.725 59.8567 59.2917 62.2833C55.7134 64.8117 49.695 66.6617 40.0634 66.6617C30.4217 66.6617 24.375 64.8433 20.7634 62.3433C17.305 59.9483 15.7867 56.7267 15.5717 52.9567C15.3467 49.04 16.5467 44.4683 18.7917 39.84C20.9334 35.4267 23.9217 31.1783 27.1334 27.7167ZM25.2167 16.5267C26.55 16.9233 27.9434 17.2683 29.3567 17.53C32.94 18.19 36.5334 18.2867 39.6 17.3983C43.1736 16.3568 46.8084 15.538 50.4834 14.9467C47.4167 14.0233 43.83 13.3333 40.0634 13.3333C34.3217 13.3333 28.9667 14.935 25.2167 16.5267Z"
                        fill="#B28800"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Repayments
                  </h3>
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>

          <div className="bg-white shadow rounded-[8px] py-[40px] px-[60px] mt-[6px] mb-[20px] flex items-center">
            {" "}
            <div className="flex-1">
              {" "}
              <h2 className="text-[24px] text-center font-ubuntu font-[500]">
                Contact Us directly on:
              </h2>{" "}
              <p className="text-[14px] text-center font-ubuntu font-[300]">
                Our 24/7 services are sure.
              </p>{" "}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 mt-8 md:mt-12 px-6 md:px-16 lg:px-24 xl:px-48 2xl:px-80 justify-center">
                <div className="bg-white shadow-lg rounded-lg py-10 px-5 flex flex-col items-center gap-y-4 transition-transform duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="60"
                      height="63"
                      viewBox="0 0 60 63"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M40.1301 4.69092L42.5451 5.37604C45.4985 6.2152 48.1907 7.85272 50.3533 10.1253C52.5159 12.3979 54.0733 15.2261 54.8701 18.3278L55.5201 20.8609L50.6951 22.2285L50.0426 19.6954C49.4732 17.4798 48.3605 15.4597 46.8156 13.8366C45.2706 12.2135 43.3473 11.044 41.2376 10.4449L38.8251 9.75717L40.1301 4.69092ZM2.50007 5.25004H23.9501L27.6676 22.8113L23.0176 27.6938C25.7516 32.1616 29.3694 35.9593 33.6251 38.829L38.2751 33.9492L55.0001 37.8525V60.375H52.5001C42.8759 60.3923 33.4536 57.478 25.3751 51.9855C19.4181 47.9377 14.3452 42.6111 10.4901 36.3563C5.25912 27.8739 2.48366 17.9804 2.50007 7.87504V5.25004ZM7.56757 10.5C7.98884 18.6898 10.4444 26.6212 14.6901 33.5055C18.1609 39.1361 22.7277 43.9312 28.0901 47.5755C34.6466 52.0335 42.2003 54.6118 50.0001 55.0542V42.063L39.8676 39.7005L34.4326 45.4099L32.7751 44.4203C26.4817 40.6651 21.2714 35.1944 17.6951 28.5863L16.7526 26.8459L22.1901 21.1392L19.9401 10.5H7.56757ZM37.8451 13.5582L40.2601 14.2433C41.7368 14.6629 43.0829 15.4816 44.1642 16.6179C45.2455 17.7542 46.0242 19.1683 46.4226 20.7192L47.0726 23.2523L42.2476 24.6199L41.5951 22.0868C41.4241 21.4221 41.0901 20.8161 40.6264 20.3292C40.1628 19.8424 39.5856 19.4917 38.9526 19.3122L36.5401 18.627L37.8451 13.5582Z"
                        fill="#1C98F7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Via mobile
                  </h3>
                </div>
                <div className="bg-white shadow-lg rounded-lg py-10 px-5 flex flex-col items-center gap-y-4 transition-transform duration-300 hover:scale-105 cursor-pointer">
                  <div>
                    <svg
                      width="60"
                      height="48"
                      viewBox="0 0 60 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.38667 47.3334C3.85111 47.3334 2.57 46.8201 1.54333 45.7934C0.516667 44.7667 0.00222222 43.4845 0 41.9468V6.05342C0 4.51786 0.514445 3.23675 1.54333 2.21008C2.57222 1.18341 3.85222 0.66897 5.38333 0.666748H54.6167C56.15 0.666748 57.43 1.18119 58.4567 2.21008C59.4833 3.23897 59.9978 4.52008 60 6.05342V41.9501C60 43.4834 59.4856 44.7645 58.4567 45.7934C57.4278 46.8223 56.1478 47.3356 54.6167 47.3334H5.38667ZM30 24.3867L3.33333 6.95008V41.9501C3.33333 42.5479 3.52555 43.039 3.91 43.4234C4.29444 43.8079 4.78667 44.0001 5.38667 44.0001H54.6167C55.2144 44.0001 55.7056 43.8079 56.09 43.4234C56.4744 43.039 56.6667 42.5467 56.6667 41.9468V6.94675L30 24.3867ZM30 20.6667L55.64 4.00008H4.36L30 20.6667ZM3.33333 6.95008V4.00008V41.9501C3.33333 42.5479 3.52555 43.039 3.91 43.4234C4.29444 43.8079 4.78667 44.0001 5.38667 44.0001H3.33333V6.95008Z"
                        fill="#1C98F7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-[16px] font-ubuntu font-[400]">
                    Via mail
                  </h3>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
